exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".app-map-container {\n  height: calc(100% - 60px);\n  display: block;\n}", "", {"version":3,"sources":["/usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/gisweb/gisweb.component.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,eAAe;CAChB","file":"gisweb.component.css","sourcesContent":[".app-map-container {\n  height: calc(100% - 60px);\n  display: block;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/gisweb/gisweb.component.css
// module id = ../../../../../src/app/components/gisweb/gisweb.component.css
// module chunks = 1